import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../helpers/api';

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem('adminToken') ? true : false
  );
  const [adminUser, setAdminUser] = useState(
    JSON.parse(localStorage.getItem('adminUser') || 'null')
  );

  const login = async (credentials) => {
    try {
      const response = await api.post('/auth/local', credentials);
      if (response.data.jwt) {
        if(!response.data.user.isAdmin){
            return false;
        }
        localStorage.setItem('adminToken', response.data.jwt);
        localStorage.setItem('adminUser', JSON.stringify(response.data.user));
        setIsAuthenticated(true);
        setAdminUser(response.data.user);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Login error:', error);
      return false;
    }
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminUser');
    setIsAuthenticated(false);
    setAdminUser(null);
  };

  return (
    <AdminAuthContext.Provider value={{ isAuthenticated, adminUser, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);